"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateBasketItem = void 0;
var BasketUpdated = _interopRequireWildcard(require("@ori-events/basket-updated"));
var UpdateBasketItem = _interopRequireWildcard(require("@ori-events/update-basket-item"));
var UpdateBasketItemFailed = _interopRequireWildcard(require("@ori-events/update-basket-item-failed"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const updateBasketItem = async ({
  itemCode,
  lineNumber,
  placement,
  previousQuantity,
  quantity
}) => new Promise((resolve, reject) => {
  const listener = event => {
    window.removeEventListener(BasketUpdated.Name, listener);
    window.removeEventListener(UpdateBasketItemFailed.Name, listener);
    const {
      detail
    } = event;
    if (UpdateBasketItemFailed.isUpdateBasketItemErrorResponse(detail)) {
      reject(new Error(`update-basket-item error: ${detail.message}`));
    } else {
      resolve();
    }
  };
  window.addEventListener(BasketUpdated.Name, listener);
  window.addEventListener(UpdateBasketItemFailed.Name, listener);
  const eventToTrigger = new CustomEvent(UpdateBasketItem.Name, {
    detail: {
      lineNumber,
      quantity,
      previousQuantity,
      newQuantity: quantity,
      itemCode,
      placement
    }
  });
  window.dispatchEvent(eventToTrigger);
});
exports.updateBasketItem = updateBasketItem;
